import React from 'react'
import { Radio } from 'antd'
import { setCurrency } from './currencySlice'
import { resetPriceFrom, resetPriceTo } from '../filter/filterSlice'
import { useDispatch } from 'react-redux'
import { RUB, EUR } from '../../utils/constants/currency'

const Currency = () => {
    const dispatch = useDispatch()

    const setRUBCurrecy = () => {
        return (dispatch) => {
            dispatch(resetPriceFrom())
            dispatch(resetPriceTo())
            dispatch(setCurrency(RUB))
        }
    }
    const onClickRUBCurrency = () => dispatch(setRUBCurrecy())

    const setEURCurrecy = () => {
        return (dispatch) => {
            dispatch(resetPriceFrom())
            dispatch(resetPriceTo())
            dispatch(setCurrency(EUR))
        }
    }

    const onClickEURCurrency = () => dispatch(setEURCurrecy())

    return (
        <>
            Валюта:
            <Radio.Group className="currencies-switcher" defaultValue="₽" buttonStyle="solid">
                <Radio.Button value="₽" onClick={onClickRUBCurrency}>
                    ₽
                </Radio.Button>
                <Radio.Button value="€" onClick={onClickEURCurrency}>
                    €
                </Radio.Button>
            </Radio.Group>
        </>
    )
}

export default Currency
